import type { Module } from "vuex";

import { USER_ROLES, type UserActions, type UserRoles } from "shared-utils/enums/user";

import type { RootState } from "@/store/types";

const storeNamespace = "roles";

export const RolesMutation = {
    SetRoles: "setRoles"
};
export const RolesAction = {
    SetRoles: `${storeNamespace}/${RolesMutation.SetRoles}`
};

export const RolesGetter = {
    getRolesThatHaveAction: `${storeNamespace}/getRolesThatHaveAction`,
    getRolesThatDoNotHaveAction: `${storeNamespace}/getRolesThatDoNotHaveAction`,
    getCollaboratorRole: `${storeNamespace}/getCollaboratorRole`
};

export type Role = {
    _id: string;
    name: UserRoles;
    actions: UserActions[];
    __typename: "UserRole";
};

export type State = {
    roles: Role[];
};

const getDefaultState = (): State => ({
    roles: []
});

const rolesModule: Module<State, RootState> = {
    namespaced: true,
    state: getDefaultState(),

    getters: {
        getRolesThatHaveAction: state => (action: UserActions) =>
            state.roles.filter(role => role.actions.includes(action)),

        getRolesThatDoNotHaveAction: state => (action: UserActions) =>
            state.roles.filter(role => !role.actions.includes(action)),

        getCollaboratorRole: state => state.roles.find(role => role.name === USER_ROLES.Collaborator)
    },

    mutations: {
        setRoles(state, roles: State["roles"]) {
            state.roles = roles;
        }
    },

    actions: {
        setRoles({ commit }, roles: State["roles"]) {
            commit(RolesMutation.SetRoles, roles);
        }
    }
};

export default rolesModule;
